import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLoopDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowLoopDownLeft"><Path d="M12.5 3C16.6421 3 20 6.35786 20 10.5V11C20 14.866 16.866 18 13 18V16C15.7614 16 18 13.7614 18 11V10.5C18 7.46243 15.5376 5 12.5 5C9.46243 5 7 7.46243 7 10.5V17.5859L9.29297 15.293L10.707 16.707L6 21.4141L1.29297 16.707L2.70703 15.293L5 17.5859V10.5C5 6.35786 8.35786 3 12.5 3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLoopDownLeft;
